<app-ep-generic-dialog [dialogTitle]="title" (cancelClick)="close()" class="error-dialog">
  <ng-container dialog-content>
    <div class="error-dialog-content">
      <app-svg-icon class="error-dialog-icon" src="./assets/icons/warning-exclamation-square.svg"></app-svg-icon>
      <span class="ep-text-strong-16 error-dialog-description" [innerHtml]="description"></span>
    </div>
  </ng-container>

  <ng-container dialog-actions>
    <div class="error-dialog-actions">
      <button *ngIf="!!actionButtonText" class="ep-btn ep-btn-primary" (click)="confirm()">
        {{ actionButtonText }}
      </button>
      <button [ngClass]="{ 'ep-btn-primary': !actionButtonText, 'ep-btn-secondary': actionButtonText }" class="ep-btn" (click)="close()">
        {{ closeButtonText }}
      </button>
    </div>
  </ng-container>
</app-ep-generic-dialog>
